module.exports = __webpack_public_path__ + "img/SAS_BlackLeatherRoundShield.854eb50d.png";